// extracted by mini-css-extract-plugin
module.exports = {"createLink":"Virtualwallets_createLink__3547F","link":"Virtualwallets_link__vkv7P"};